import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=1f1c8e78&scoped=true&lang=html"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=1f1c8e78&prod&lang=css"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=1f1c8e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c8e78",
  null
  
)

export default component.exports